import { CanvasTexture, Mesh, MeshBasicMaterial, PlaneGeometry, type Texture } from 'three';
import type { TileType } from '../core/types.js';
import { GLYPH_FOR_TILE } from '../core/specials.js';

const TEXTURE_CACHE = new Map<string, Texture>();

const drawGlyph = (glyph: string, fg: string, size = 256): HTMLCanvasElement => {
  const c = document.createElement('canvas');
  c.width = size;
  c.height = size;
  const ctx = c.getContext('2d');
  if (!ctx) return c;
  ctx.clearRect(0, 0, size, size);
  ctx.fillStyle = fg;
  ctx.font = `bold ${size * 0.62}px -apple-system, "Helvetica Neue", Arial, sans-serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.shadowColor = 'rgba(0,0,0,0.35)';
  ctx.shadowBlur = size * 0.04;
  ctx.fillText(glyph, size / 2, size / 2 + size * 0.04);
  return c;
};

export const glyphTexture = (tile: TileType): Texture | null => {
  if (tile === 'normal') return null;
  const cached = TEXTURE_CACHE.get(tile);
  if (cached) return cached;
  const isDark = tile === 'locked' || tile === 'penalty';
  const fg = isDark ? '#ffffff' : '#1a1d29';
  const tex = new CanvasTexture(drawGlyph(GLYPH_FOR_TILE[tile], fg));
  tex.anisotropy = 4;
  TEXTURE_CACHE.set(tile, tex);
  return tex;
};

export const buildGlyphMesh = (tile: TileType, cellSize: number): Mesh | null => {
  const tex = glyphTexture(tile);
  if (!tex) return null;
  const geo = new PlaneGeometry(cellSize * 0.78, cellSize * 0.78);
  const mat = new MeshBasicMaterial({ map: tex, transparent: true, depthWrite: false });
  const mesh = new Mesh(geo, mat);
  mesh.position.z = 0.43;
  mesh.renderOrder = 2;
  return mesh;
};
